import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbRelatorioUnidades } from 'app/abstract/full-pages/relatorios/relatorio-unidades.abstract';

@Injectable({ providedIn: 'root' })
export class RelatorioUnidadesServices extends AbRelatorioUnidades {

    constructor(http: HttpClient) {
        super(http);
    }

    getRelatorioUnidades(filter: String): Observable<any> {
        return this.get(`relatorio_unidades/listar/${filter}`);
    }

    getRelatorioCompleto(filter: String): Observable<any> {
        return this.get(`relatorio_unidades/completo/${filter}`);
    }

    getRelatorio(filter: string): Observable<any> {
        return this.get(`relatorio_unidades/gerar/${filter}`);
    }

}